import type { RootState as State } from 'vms/app/rootReducer';
import type { GroupType } from 'vms/generated/groups';

import type { User } from './types';

export interface UserDirectoryFilters {
  is_active?: boolean;
  location?: string;
  roles?: string[];
  group?: GroupType;
  has_roles?: boolean;
  search?: string;
}

export const filterUserDirectory = (
  users: User[],
  filters: UserDirectoryFilters = {}
) => {
  const search = filters.search?.trim().toLowerCase();
  return users.filter(
    (user) =>
      (filters.is_active === undefined || user.is_active === filters.is_active) &&
      (!filters.location || user.location === filters.location) &&
      (!filters.group || user.groups.includes(filters.group)) &&
      (!filters.roles?.length ||
        filters.roles.some((role) => user.roles?.includes(role))) &&
      (filters.has_roles === undefined ||
        Boolean(user.roles?.length) === filters.has_roles) &&
      (!search ||
        user.name.toLowerCase().includes(search) ||
        user.email.toLowerCase().includes(search))
  );
};

export interface UserSelectionFilters {
  group?: GroupType;
  locationId?: string;
}

export const selectCurrentUserId = (state: State) => state.accounts.currentUserId;
